import { useCallback } from 'react'
import { FormikErrors } from 'formik'
import { IReOpenFormModel } from '@user/components/Leads/ReOpenDialog/ReOpenLeadDialog'

export function useActions() {
  const validate = useCallback((model: IReOpenFormModel) => {
    const errors: FormikErrors<IReOpenFormModel> = {}

    const { salesFunnelStageId, owner } = model
    if (salesFunnelStageId === null) {
      errors.salesFunnelStageId = 'Required'
    }
    if (owner === null) {
      errors.owner = 'Required'
    }

    return errors
  }, [])

  return {
    validate,
  }
}
